export default "__VITE_ASSET__ClWE9IEZ__"